export default __webpack_public_path__ + "static/media/eos-asem-logo.38b026ae.png";